import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
//import Breadcrumbs
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import DataTableHelper from "../../../helpers/tables/DataTableHelper";
import Columns from "./Columns";
import AddUpdModal from "./AddUpdModal";
import {
  resourcesInstallationTypes,
  deleteUser,
} from "../../../helpers/backend_helper";
import {
  DestroyAlertHelper,
  Alert,
  ToastHelper,
} from "../../../helpers/alerts/alertHelper";
import { getPolicyUser } from "../../../helpers/api_helper";
import { Container } from "reactstrap";

const InstallationTyipes = () => {
  const policy = getPolicyUser();
  const [pending, setPending] = useState(false);
  const [modal, setModal] = useState({ show: false, update: false });
  const [dataPag, setDataPag] = useState({});
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "id",
    order: "asc",
  });
  const [items, setItems] = useState([]);
  const [itemBase, setBase] = useState({
    id: 0,
    name: "",
    order: "",
  });
  const [user, setUser] = useState(itemBase);
  const dispatch = useDispatch();
  useEffect(() => {
    //ToastHelper('mensaje','error')
    let params = { params: filters };
    setPending(true);
    resourcesInstallationTypes("get", params).then((response) => {
      setItems(response.data);
      setDataPag(response.meta);
      //console.log(response)
      setPending(false);
    });
  }, [filters]);
  const addUpd = (row = false) => {
    if (row.id) {
      setUser(row);
      setModal({ ...modal, show: true, update: true });
    } else {
      console.log(itemBase);
      setUser(itemBase);
      setModal({ ...modal, show: true, update: false });
    }
  };
  const destroy = (id) => {
    DestroyAlertHelper(async (confirmed) => {
      if (!confirmed) {
        return;
      }
      resourcesInstallationTypes("del", id, id).then((response) => {
        Alert(response.message, response.status);
        if (response.status) {
          setItems(items.filter((i) => i.id != id));
        }
      });
    });
  };

  const columns = Columns(addUpd, destroy);
  document.title = "Tipos de instalacón | Catalogos";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              tittle="Tipos de instalacón"
              columns={columns}
              items={items}
              pending={pending}
              config={dataPag}
              filters={filters}
              setFilters={setFilters}
            >
              <div className="col-md-2 ms-auto float-end">
                <button
                  className="btn btn-sm btn-primary float-end ms-2"
                  onClick={() => addUpd()}
                >
                  <i className="fas fa-solid fa-plus"></i> Agregar
                </button>
              </div>
            </DataTableHelper>
          </div>
        </Container>
        {modal.show && (
          <AddUpdModal
            modal={modal}
            setModal={setModal}
            items={items}
            setItems={setItems}
            item={user}
            setItem={setUser}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default InstallationTyipes;
